import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { CONTINUE_ONLINE_FULL_PATH, CONTINUE_ONLINE_SUBSTANCE_USE_PATH } from 'routes/constants';

import { UNDERWRITING_STEPS } from './steps';

export const underWritingDIPDS = [
  'urn:pg:data-point:insured-gender',
  'urn:pg:data-point:insured-condition-high-blood-pressure',
  'urn:pg:data-point:insured-condition-high-cholesterol',
  'urn:pg:data-point:insured-condition-add-adhd',
  'urn:pg:data-point:insured-condition-anxiety',
  'urn:pg:data-point:insured-risk-condition-family-health-history',
  'urn:pg:data-point:insured-risk-condition-marijuana',
  'urn:pg:data-point:insured-risk-activity-adverse-driving',
];
const useNavigateUnderwritingStep = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(
    (healthConditions: Record<string, any> | undefined) => {
      if (!healthConditions) {
        navigate(`../${CONTINUE_ONLINE_SUBSTANCE_USE_PATH}`);

        return;
      }
      const currentPathIdx = UNDERWRITING_STEPS.findIndex(
        (step) => `${CONTINUE_ONLINE_FULL_PATH}/${step.path}` === pathname
      );
      const futureSteps = UNDERWRITING_STEPS.slice(currentPathIdx + 1);
      const nextUnderwritingStep = futureSteps.find(
        (healthStep) => healthConditions[healthStep.key] === healthStep.value
      );

      if (nextUnderwritingStep) {
        navigate(`../${nextUnderwritingStep.path}`);
      } else {
        navigate(`../${CONTINUE_ONLINE_SUBSTANCE_USE_PATH}`);
      }
    },
    [navigate, pathname]
  );
};

export default useNavigateUnderwritingStep;
